
import { IPackage, IInvoice } from "@/interfaces/mlm";
import {
  dispatchGetOrCreateInvoice,
  dispatchGetPackages,
  dispatchGetPaymentStatus,
  dispatchProcessConfirmInvoice, dispAuthFetch,
} from "@/store/mlm/actions";
import { readActivePackage, readInvoiceResponse } from "@/store/mlm/getters";
import { Component, Vue, Prop } from "vue-property-decorator";
import { dispatchGetUserProfile, dispatchGetUsdtDexnetRate } from "@/store/main/actions";
import { readUserProfile } from "@/store/main/getters";
import ChangeEmailModal from "@/components/Main/ChangeEmailModal.vue";
import ByTariffFromDexNetTokenModal from "@/components/Main/ByTariffFromDexNetTokenModal.vue";
import ByVirtualTariffFromDexNetTokenModal from "@/components/Main/ByVirtualTariffFromDexNetTokenModal.vue";
import {DEXNET_DISCOUNT} from "@/constants";

@Component({
  components: {ByVirtualTariffFromDexNetTokenModal, ByTariffFromDexNetTokenModal, ChangeEmailModal},
})
export default class PackagePaymentVirtualModal extends Vue {
  // @ts-ignore
  @Prop({ required: true, default: false }) public readonly modalShow: boolean;
  // @ts-ignore
  @Prop({ required: true, default: null }) public readonly pack: any;

  public loadingState: any = {
    standart: false,
    submit: false,
  };
  public paymentMethod: string = "";
  public standart: string = "";
  public invoiceDetail: IInvoice | null = null;
  public transaction: any = null;
  public progressPercent = 100;
  public timeToReload = 15;
  public isModalClosed: boolean = false;
  // public isShowModalByTariffFromDexNetToken: boolean = false
  public myReferral: any = null
  public isChecked = false
  public isConfirmFixDexnet = false
  public invoiceId = null
  public errorMessage = ""
  public purchaseRequest = null
  public priceDexNet = 0

  public async mounted() {
    // by default USDT request Invoice on mounted and get amount if DexNet for priceDexnet
    await this.requestInvoice(this.getTokenByPaymentMethod());

      this.myReferral = await this.informationMy()
  }

  // Methods
  public async changePaymentMethod(selectedToken: string) {
    // Проверяем, действительно ли изменился метод оплаты
    if (this.paymentMethod === selectedToken) {
      return; 
    }
    
    this.paymentMethod = selectedToken;
    
    await this.requestInvoice(this.getTokenByPaymentMethod());
  }

  public async informationMy() {
    const invoiceResp = await dispAuthFetch(this.$store, {
      input: "/api/v1/mlm/referral_confirmation/",
      init: {
        method: "GET",
      },
    });

    if (invoiceResp.status === 200) {
      const invoiceResponse = await invoiceResp.json();
      return invoiceResponse;
    } else {
      this.$toast.error("Failed to create invoice, please try again later", {
        message: "Failed to create invoice, please try again later",
        duration: 3000,
        position: "bottom",
      });
      return null;
    }
  }

  public async updateProgressBar() {
    if (this.isModalClosed) {
      return;
    }

    this.progressPercent = this.progressPercent - 6.66;
    this.timeToReload = this.timeToReload - 1;
    if (this.progressPercent > 0) {
      setTimeout(() => this.updateProgressBar(), 1000);
    } else {
      await dispatchGetUserProfile(this.$store);
      this.progressPercent = 100;
      this.timeToReload = 15;
      await this.updatePaymentInfo();
      this.updateProgressBar();
    }
  }

  public async handleProcessPayment() {
    if(!this.isChecked) return;

    if(this.paymentMethod == "DexNetToken" && !this.isConfirmFixDexnet) return;

    this.loadingState.submit = true
    this.errorMessage = ""

    if (this.invoiceId) {
      if(this.paymentMethod === 'wallet'){
        const invoiceResp = await dispAuthFetch(this.$store, {
          input: "/api/v1/mlm/virtual_node/purchase/confirm/",
          init: {
            method: "POST",
            body: {
              invoice: this.invoiceId,
              email: this?.userProfile?.email
            },
          },
        });

        if (invoiceResp && invoiceResp.status === 200) {
          this.purchaseRequest = await invoiceResp.json()
          this.$toast.success(this.$t('successfully').toString())
          this.$emit('update-virtnodes');
          this.closeModal()
        } else if (invoiceResp && invoiceResp.status === 400) {
          const error = await invoiceResp.json()
          if(error.email)
            this.errorMessage = this.$t("Invalid email").toString()
          if(error.detail)
            this.errorMessage = this.$t('This package is temporarily unavailable').toString()
          if(error.invoice)
            this.errorMessage = this.$t('Insufficient funds').toString()
          this.$toast.error(this.$t("ERROR").toString() + ": " + this.errorMessage);
        }

        this.loadingState.submit = false
      } else if(this.paymentMethod === 'DexNetToken'){
        const invoiceResp = await dispAuthFetch(this.$store, {
          input: "/api/v1/mlm/virtual_node/purchase/confirm/",
          init: {
            method: "POST",
            body: {
              invoice: this.invoiceId,
              email: this?.userProfile?.email
            },
          },
        });

        if (invoiceResp && invoiceResp.status === 200) {
          this.purchaseRequest = await invoiceResp.json()
          this.$toast.success(this.$t('successfully').toString())
          this.$emit('update-virtnodes');
          this.closeModal()
        } else if (invoiceResp && invoiceResp.status === 400) {
          const error = await invoiceResp.json()
          if(error.email)
            this.errorMessage = this.$t("Invalid email").toString()
          if(error.detail)
            this.errorMessage = this.$t('This package is temporarily unavailable').toString()
          if(error.invoice)
            this.errorMessage = this.$t('Insufficient funds').toString()
          this.$toast.error(this.$t("ERROR").toString() + ": " + this.errorMessage);
        }

        this.loadingState.submit = false
      }
      // else if(this.paymentMethod === 'DexNetToken'){
      //   this.isShowModalByTariffFromDexNetToken = true
      // }
    }
  }

  public needSomeMoney() {
    if(this.paymentMethod === 'DexNetToken'){
      const balance = this.userProfile
        ? Number(this.userProfile.balances.dtin)
        : 0;
    const r = Math.abs(balance - this.priceDexNet)
    return Math.round(r);
    }
    else {
    const balance = this.userProfile
        ? Number(this.userProfile.balances.units_total)
        : 0;
    const r = Math.abs(balance - this.pack.usdt_price)
    return Math.round(r);
    }
  }
  
  public async updatePaymentInfo() {
    if (this.invoiceResponse && this.invoiceDetail) {
      const paymentResponse = await dispatchGetPaymentStatus(this.$store, {
        address: this.invoiceResponse.address,
        invoice: this.invoiceDetail.id,
      });
      if (paymentResponse) {
        this.invoiceDetail = paymentResponse.invoice;
        // this.transaction = paymentResponse.transaction;
      }
      // this.progressPercent = 100;
      // this.timeToReload = 15;
      // this.updateProgressBar();
    }
  }

  public closeModal() {
    this.isModalClosed = true;
    this.$emit("close-modal");
  }

  public getTokenByPaymentMethod(): string {
    if (this.paymentMethod === 'DexNetToken') {
      return 'DEXNET';
    }
    // По умолчанию возвращаем USDT (для paymentMethod === 'wallet' или пустого значения)
    return 'USDT';
  }

  public async requestInvoice(token: string) {
    const invoiceResp = await dispAuthFetch(this.$store, {
      input: "/api/v1/mlm/virtual_node/purchase/request/",
      init: {
        method: "POST",
        body: {
          virtual_node: this.pack.id,
          standart: "BEP20",
          token: token
        },
      },
    });

    if (invoiceResp && invoiceResp.status === 200) {
      //  this.invoiceId = (await invoiceResp.json()).invoice.id
     
      const invoiceData = (await invoiceResp.json()).invoice
      this.invoiceId = invoiceData.id

      if(invoiceData.currency === "DTIN"){
        this.priceDexNet = invoiceData.amount
      }
    } else if (invoiceResp && invoiceResp.status === 400) {
      this.$toast.error("Error");
    }
  }

  get invoiceResponse() {
    return readInvoiceResponse(this.$store);
  }

  get activePackage() {
    return readActivePackage(this.$store);
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }
}
